import { f as e } from "./fails.js";
var t = !e(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});
export { t as f };